import { render, staticRenderFns } from "./LampGroup.vue?vue&type=template&id=c180bfde&scoped=true&"
import script from "./LampGroup.vue?vue&type=script&lang=js&"
export * from "./LampGroup.vue?vue&type=script&lang=js&"
import style0 from "./LampGroup.vue?vue&type=style&index=0&id=c180bfde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c180bfde",
  null
  
)

export default component.exports